// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({"1367": "ModelViewer","2257": "EthereumWallet","582": "NftSecondaryMarketModal","7530": "ActionToast","7581": "NftPdpZoomModal","8692": "RecentlyViewed",}[chunkId] || chunkId) + ".558.0.0." + {"1367": "1f7fb07a98aed35c","2257": "7a4001e3cb1e8301","2973": "0016d4ba1d69435e","582": "a46e2df54e529433","7530": "ead492d5a988408e","7581": "355f4f95fa8fee71","8692": "83671d8b12cf6da2",}[chunkId] + ".css"
}